<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>商品列表</span>
				<el-button class="button" @click='edit("")' type="success">新增商品</el-button>
			</div>
		</template>
		<div class="col">
			<Search ref='searchProductConditions' @inputValue="inputSearch" />
			<el-tabs v-model="activeName">
				<el-tab-pane label="全部商品" name="first">
					<el-table height="700"  v-loading="loading" :data="productSellData.data"
					 style="width: 100%;" :default-sort="sort_sell" border highlight-current-row>
						<el-table-column prop="id" label="编号" sortable width="180">
						</el-table-column>
						<el-table-column prop="product_model" label="版号" sortable width="180">
						</el-table-column>
						<el-table-column prop="product_name" label="商品名">
						</el-table-column>
						<el-table-column prop="price" label="价格区间" sortable>
							<template #default='scope'>
								<span>
									{{scope.row.priceMaxAndMin.min.value}}~{{scope.row.priceMaxAndMin.max.value}}
								</span>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="product_count" label="总销量" sortable>
							11
						</el-table-column> -->
						<el-table-column align="left" width="400">
							<template #header>
								<span>操作</span>
							</template>
							<template #default="scope">
								<el-button type="primary" size="medium" @click="product_view(scope.row.product_name,scope.row.id)">商品预览</el-button>
								<el-button type="primary" size="medium" @click="edit(scope.row)">编辑</el-button>
								<el-button type="warning" size="medium" @click='shelves(scope.row.product_name,scope.row.id,scope.row.product_status)' v-if="scope.row.product_status==2">已下架</el-button>
								<el-button type="success" size="medium" @click='shelves(scope.row.product_name,scope.row.id,scope.row.product_status)' v-else>已上架</el-button>
								<el-button v-if="this.localGet('userId')==1" type="danger" size="medium" @click="destroy(scope.$index, scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<pages :total="total_Sell" :pageSize="pageSize_Sell" @handleSizeChangeSub="handleSizeChangeFun_Sell" @handleCurrentChangeSub="handleCurrentChangeFun_Sell"></pages>
				</el-tab-pane>
				<!-- <el-tab-pane label="已下架" name="second">
					<el-table height="700" v-loading="loading" :data="productShelvesData.data"
					 style="width: 100%;" :default-sort="sort_shelves" border highlight-current-row>
						<el-table-column prop="id" label="编号" sortable width="180">
						</el-table-column>
						<el-table-column prop="product_model" label="版号" sortable width="180">
						</el-table-column>
						<el-table-column prop="product_name" label="商品名">
						</el-table-column>
						<el-table-column prop="price" label="价格区间" sortable>
							<template #default='scope'>
								<span>
									{{scope.row.priceMaxAndMin.min.value}}~{{scope.row.priceMaxAndMin.max.value}}
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="product_count" label="总销量" sortable>
							11
						</el-table-column>
						<el-table-column align="left" width="300">
							<template #header>
								<span>操作</span>
							</template>
							<template #default="scope">
								<el-button type="primary" size="medium" @click="edit(scope.row)">编辑</el-button>
								<el-button type="warning" size="medium" @click='shelves(scope.row.product_name,scope.row.id,scope.row.product_status)' v-if="scope.row.product_status==2">已下架</el-button>
								<el-button type="warning" size="medium" @click='shelves(scope.row.product_name,scope.row.id,scope.row.product_status)' v-else>已上架</el-button>
								<el-button type="danger" size="medium" @click="destroy(scope.$index, scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<pages :total="total_Shelves" :pageSize="pageSize_Shelves" @handleSizeChangeSub="handleSizeChangeFun_Shelves" @handleCurrentChangeSub="handleCurrentChangeFun_Shelves"></pages>
				</el-tab-pane> -->
				
			</el-tabs>
		</div>
	</el-card>
</template>

<script>
	import Search from '../common/Search.vue'
	import pages  from'../common/Pagination.vue'

	export default {
		name: 'ProductList',
		data() {
			return {
				activeName: 'first',
				loading: true,
				// total_Shelves: 0,
				// currentPage_Shelves: 1,
				// pageSize_Shelves: 5,
				total_Sell: 0,
				currentPage_Sell: 1,
				pageSize_Sell: 10,
				productSellData:[],
				// productShelvesData:[],
				// sort_shelves: {
				// 	prop: 'id',
				// 	order: 'descending'
				// },
				sort_sell: {
					prop: 'id',
					order: 'descending'
				},
				searchProductConditions: {
					product_name:'',
					product_model:'',
					product_status:'',
				},

			}
		},
		components: {
			Search,
			pages,
		},
		methods: {
			inputSearch(inpVal) {
				console.log(inpVal)
				// this.loading = true;
				this.searchProductConditions.product_name = inpVal.product_name
				this.searchProductConditions.product_model = inpVal.product_model
				this.searchProductConditions.product_status = inpVal.product_status
				this.searchProductConditions.product_sale_type = inpVal.product_sale_type


				this.loading = true;
				
				this.getProductSellData();
			},
			getMinAndMaxPrice(val) {
				console.log(val)
			},
			product_view(name,id){
				// console.log(name,id)
				let product_url = this.webHost()+'/p'+id+'.html';
				window.open(product_url, '_blank');
			},
			edit(row) {
				// this.$router.push({
				// 	path: '/main/product_edit',
				// 	query: {
				// 		id: row.id
				// 	}
				// })
				let routeData = this.$router.resolve({ path: '/main/product_edit',query:{
						id: row.id
					}});
					// console.log(routeData)
				window.open(routeData.href, '_blank');
			},
			shelves(name,id,status){
				let release_name = ''
				if(status==2){
					this.release_name = '上架'
				}else{
					this.release_name = '下架'
				}
				this.msgBoxAjax('是否将:'+name+this.release_name, '确定更改吗?', '/admin/product/productReleaseStatus', {
					id: id,
					status:status
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.alertSuccess('成功')
					this.getProductSellData();
				})
			},
			destroy(index,row) {
				let id = row.id
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/product/productDelete', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getProductSellData();
				})
			},
			handleSizeChangeFun_Sell(page){
				
				this.pageSize_Sell = page;
				this.getProductSellData();
			},
			handleCurrentChangeFun_Sell(page){
				
				this.currentPage_Sell = page;
				this.getProductSellData();
			},
			getProductSellData(){
				//有搜索条件时  获得出售中的商品数据
				//没有搜索条件时  获得出售中的商品数据
				console.log(this.searchProductConditions)
				let searchConditionsData = []
				if(this.searchProductConditions.product_name!='' || this.searchProductConditions.product_model!='' || this.searchProductConditions.product_status!='' || this.searchProductConditions.product_sale_type!=''){
					searchConditionsData = this.searchProductConditions;
				}
				this.httpPost({
					url: '/admin/product/productSellDataList',
					data:{p:this.currentPage_Sell,searchConditions:searchConditionsData,routePath: this.$route.path},
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.productSellData = temp;
					this.total_Sell = re.data.total;
					this.currentPage_Sell = re.data.currentPage;
					this.pageSize_Sell = re.data.pageSize
					this.loading = false;
				
				}).catch((err) => {
					this.loading = false;
				})
			},
		},
		created(){
			this.getProductSellData();
		}

	}
</script>

<style>
	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.box-card {
		/* width: 480px; */
	}
</style>
